module.exports = __webpack_public_path__ + "img/search.a2a71174.svg";